import script from "./OrganizationNameSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationNameSettings.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationNameSettings.vue?vue&type=style&index=0&id=557e3bd3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-557e3bd3"]])

export default __exports__